// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m["default"] || m;
};

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": function componentNodeModulesGatsbyPluginOfflineAppShellJs() {
    return import("./../gatsby-plugin-offline/app-shell.js"
    /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */
    );
  },
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-contact-js": function componentSrcPagesContactJs() {
    return import("./../../src/pages/contact.js"
    /* webpackChunkName: "component---src-pages-contact-js" */
    );
  },
  "component---src-pages-generic-js": function componentSrcPagesGenericJs() {
    return import("./../../src/pages/Generic.js"
    /* webpackChunkName: "component---src-pages-generic-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-portfolio-chrome-extension-js": function componentSrcPagesPortfolioChromeExtensionJs() {
    return import("./../../src/pages/portfolio/chrome-extension.js"
    /* webpackChunkName: "component---src-pages-portfolio-chrome-extension-js" */
    );
  },
  "component---src-pages-portfolio-explore-js": function componentSrcPagesPortfolioExploreJs() {
    return import("./../../src/pages/portfolio/explore.js"
    /* webpackChunkName: "component---src-pages-portfolio-explore-js" */
    );
  },
  "component---src-pages-portfolio-julia-js": function componentSrcPagesPortfolioJuliaJs() {
    return import("./../../src/pages/portfolio/julia.js"
    /* webpackChunkName: "component---src-pages-portfolio-julia-js" */
    );
  },
  "component---src-pages-portfolio-pocket-budget-js": function componentSrcPagesPortfolioPocketBudgetJs() {
    return import("./../../src/pages/portfolio/pocket-budget.js"
    /* webpackChunkName: "component---src-pages-portfolio-pocket-budget-js" */
    );
  },
  "component---src-pages-portfolio-roi-calculator-js": function componentSrcPagesPortfolioRoiCalculatorJs() {
    return import("./../../src/pages/portfolio/roi-calculator.js"
    /* webpackChunkName: "component---src-pages-portfolio-roi-calculator-js" */
    );
  },
  "component---src-pages-portfolio-yoga-dice-js": function componentSrcPagesPortfolioYogaDiceJs() {
    return import("./../../src/pages/portfolio/yoga-dice.js"
    /* webpackChunkName: "component---src-pages-portfolio-yoga-dice-js" */
    );
  },
  "component---src-pages-portfolio-yogi-library-js": function componentSrcPagesPortfolioYogiLibraryJs() {
    return import("./../../src/pages/portfolio/yogi-library.js"
    /* webpackChunkName: "component---src-pages-portfolio-yogi-library-js" */
    );
  },
  "component---src-pages-resources-student-resources-js": function componentSrcPagesResourcesStudentResourcesJs() {
    return import("./../../src/pages/resources/student-resources.js"
    /* webpackChunkName: "component---src-pages-resources-student-resources-js" */
    );
  },
  "component---src-pages-story-js": function componentSrcPagesStoryJs() {
    return import("./../../src/pages/story.js"
    /* webpackChunkName: "component---src-pages-story-js" */
    );
  }
};